import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useSocialSummary } from '../services/queries';
import { BellIcon } from './Icons';

function CountBadge({ count, label }: { count: number; label: string }) {
  if (count <= 0) return null;
  return (
    <span className="count-badge">
      {count > 99 ? '99+' : count}
      <span className="visually-hidden"> {label}</span>
    </span>
  );
}

export function NotificationBell() {
  const { t } = useTranslation();
  const summary = useSocialSummary();
  const unread = summary.data?.unreadNotifications ?? 0;

  return (
    <Link to="/notifications" className="hud__bell" aria-label={unread > 0 ? t('nav.notificationsUnread', { count: unread }) : t('nav.notifications')}>
      <BellIcon size={22} />
      <CountBadge count={unread} label={t('nav.badgeUnread')} />
    </Link>
  );
}
